"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _draftJs = require("draft-js");

var _draftHelpers = require("composer-plugins/lib/draftHelpers");

var _constants = require("composer-plugins/lib/constants");

var QUESTION_AND_ANSWER_ENTITY_KEY = _constants.ENTITY_TYPES.questionAndAnswer;
var LEGACY_INTERACTIVE_CONTENT_ENTITY_KEY = _constants.ENTITY_TYPES.interactiveSalesContent;
var supportedEntityTypes = (0, _immutable.List)([QUESTION_AND_ANSWER_ENTITY_KEY, LEGACY_INTERACTIVE_CONTENT_ENTITY_KEY]);

var _default = function _default(editorState) {
  var contentState = editorState.getCurrentContent();
  var blockMap = contentState.getBlockMap();
  var questionAndAnswer = blockMap.filter(function (block) {
    var blockType = block.getType();
    var entity = (0, _draftHelpers.getDefaultEntity)(block, editorState.getCurrentContent().getEntity);
    return blockType === 'atomic' && entity && supportedEntityTypes.includes(entity.getType());
  });
  return _draftJs.ContentState.createFromBlockArray(questionAndAnswer.toArray());
};

exports.default = _default;
module.exports = exports.default;